import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, Form, Button, Modal, Table } from 'react-bootstrap';
import Calendar from 'react-calendar';
import { ToastContainer } from 'react-toastify';
import { format } from 'date-fns';
import { FaExpand, FaCompress } from 'react-icons/fa';
import { BiFullscreen, BiExitFullscreen } from "react-icons/bi";
import moment from 'moment'; import { Container, Image, Dropdown } from "react-bootstrap";
import loginPhoto from '../../assets/images/common/loginPhoto.png';
import { FaSignOutAlt } from "react-icons/fa";
import TimetableForm from '../timetable/addtimetable';
import axios from 'axios';
import { FaFilePdf } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import excelIcon from '../../assets/icons/excel.png';
import pdfIcon from '../../assets/icons/pdf.png';
import { toast } from 'react-toastify';
import PageInfoStatus from "../../components/layout/pageInfoStatus/pageInfoStatus";
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import 'react-calendar/dist/Calendar.css';
import '../dashboard/dashboard.css';
import loading from "../../assets/images/common/loading.gif";
const Dashboard = () => {
  const navigate = useNavigate();
  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  useEffect(() => {
    if (userObj?.role_name?.trim()?.toLowerCase() === 'child future admin') {
      navigate('/finance/reports');
    }
  }, [userObj, navigate]);

  const [overallAttendancePie, setOverallAttendancePie] = useState({
    present: 0,
    absent: 0
  });
  // Employee Attendance
  const [employeeView, setEmployeeView] = useState("Daywise");
  const [showEmployeeAttendanceModal, setShowEmployeeAttendanceModal] = useState(false);

  const [employeeAttendanceDate, setEmployeeAttendanceDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [employeeAttendance, setEmployeeAttendance] = useState([]);
  const [isLoadingEmployee, setIsLoadingEmployee] = useState(false);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const fetchEmployeeAttendance = async () => {
    try {
      setIsLoadingEmployee(true);

      const response = await axios.get(
        baseUrl + "/employeeattendancemonthlyreport",
        {
          params: {
            _school_id: userObj?.school_id,
            _attendance_date: employeeAttendanceDate || undefined,
            // You can also send view_type: employeeView if you later handle Trend in backend
          },
        }
      );

      setEmployeeAttendance(response.data || []);
    } catch (error) {
      console.error("Error fetching employee attendance:", error);
      setEmployeeAttendance([]);
    } finally {
      setIsLoadingEmployee(false);
    }
  };

  const [trendChartType, setTrendChartType] = useState("bar");
  const apiUrl = `${baseUrl}/uploads/get-image/${userObj.logo}`;
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    const fetchProfilePhoto = async () => {
      if (!userObj?.user_id) return;
      try {
        const response = await axios.get(`${baseUrl}/main/getemployeeprofilephoto`, {
          params: { _emp_id: userObj.user_id }
        });
        if (response.data && response.data.length > 0) {
          const photo = response.data[0].profile_photo;
          if (photo) {
            const trimmedPhoto = photo.trim();
            if (trimmedPhoto.startsWith('data:image/') || trimmedPhoto.startsWith('data:application/')) {
              setAvatarUrl(trimmedPhoto);
            } else if (/^[a-zA-Z0-9+/=]+$/.test(trimmedPhoto) && trimmedPhoto.length > 100) {
              setAvatarUrl(`data:image/png;base64,${trimmedPhoto}`);
            } else {
              setAvatarUrl(`${baseUrl}/uploads/get-image/${trimmedPhoto}`);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching employee profile photo:', error);
      }
    };

    fetchProfilePhoto();
  }, [userObj?.user_id, baseUrl]);

  const handleLogout = () => {
    sessionStorage.removeItem('user');
    window.location.href = '/';
  };
  const fetchAttendanceSummary = async (classId = '', sectionId = '', timeFilter = 'day') => {
    const today = new Date().toISOString().split('T')[0];

    // Convert timeFilter to backend-compatible type value
    let typeValue = '';
    if (timeFilter === 'day') typeValue = 'This Day';
    else if (timeFilter === 'week') typeValue = 'This Week';
    else if (timeFilter === 'month') typeValue = 'This Month';

    try {
      const response = await axios.post(baseUrl + '/getattendancesummary/', {
        action: 'FILTER',
        type: typeValue,
        attendance_date: today,
        school_id: selectedSchool,
        academic_year_id: selectedAcademicYear,
        class_id: classId || 0,
        section_id: sectionId || 0
      });

      const data = response.data;
      const present = data.total_present_students || 0;
      const absent = data.total_absent_students || 0;
      const total = present + absent;

      setSummaryAttendanceData({
        present,
        absent,
        total,
        percentage: total > 0 && timeFilter !== 'day'
          ? ((present / total) * 100).toFixed(1)
          : null
      });
    } catch (error) {
      console.error('Error fetching attendance summary:', error);
      setSummaryAttendanceData({
        present: 0,
        absent: 0,
        total: 0,
        percentage: null
      });
    }
  };

  const getTrendChartOption = () => {


    if (trendChartType === "bar") {
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
        },
        legend: {
          top: 10,
          data: ['Present', 'Absent'],
        },
        grid: {

          bottom: '6%',
          containLabel: true, // ✅ prevents label clipping
        },
        xAxis: {
          type: 'category',
          data: sortedTrendData.map(item =>
            typeof item?.day === "string" ? item.day.slice(-2) : ""
          ),
          axisLabel: {
            fontSize: 12,
          }
        },
        yAxis: {
          type: 'value',
          name: 'Students',
          axisLabel: {
            fontSize: 12,
          }
        },
        series: [
          {
            name: 'Present',
            type: 'bar',
            barWidth: '40%',
            data: sortedTrendData.map(item => item.Present || 0),
            itemStyle: {
              color: '#81C784',
            },
            // label: {
            //   show: true,
            //   position: 'top',           // ✅ label on top of bar
            //   color: 'grey',
            //   fontSize: 12,
            //   fontWeight: 'bold',
            //   formatter: '{c}'           // ✅ shows value
            // },
            labelLayout: {
              hideOverlap: true          // ✅ prevent collision
            }
          },
          {
            name: 'Absent',
            type: 'bar',
            barWidth: '40%',
            data: sortedTrendData.map(item => item.Absent || 0),
            itemStyle: {
              color: '#E57373',
            },
            // label: {
            //   show: true,
            //   position: 'top',           // ✅ label on top
            //   color: 'grey',
            //   fontSize: 12,
            //   fontWeight: 'bold',
            //   formatter: '{c}'
            // },
            labelLayout: {
              hideOverlap: true
            }
          }
        ]
      };
    }

    if (trendChartType === "pie") {
      return {
        title: {
          text: 'Overall Attendance (Today)',
          left: 'center',
          textStyle: { fontSize: 14 },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          To: '0%',
          data: ['Present', 'Absent'],
          textStyle: { fontSize: 11 },
        },
        series: [
          {
            name: 'Attendance',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [
              { value: overallAttendancePie.present || 0, name: 'Present' },
              { value: overallAttendancePie.absent || 0, name: 'Absent' }
            ],
            label: {
              formatter: '{b}: {c} ({d}%)',
              fontSize: 12,
            }
          }
        ]
      };
    }
    return {};
  };

  const getSummaryChartOption = () => {
    const { present, absent, total } = summaryAttendanceData;

    const showCounts = summaryTimeFilter === 'day';

    return {
      title: {
        text: summaryClass && summarySection
          ? ` ${classList.find(c => c.class_id == summaryClass)?.class_name} - ${sectionList.find(s => s.section_id == summarySection)?.section_name} `
          : summaryClass
            ? ` ${classList.find(c => c.class_id == summaryClass)?.class_name}`
            : summaryTimeFilter === 'week'
              ? 'Overall School Attendance (This Week)'
              : summaryTimeFilter === 'month'
                ? 'Overall School Attendance (This Month)'
                : 'Overall School Attendance (Today)',
        left: 'left',
        textStyle: { fontSize: 14 },
        top: 10
      },
      tooltip: {
        trigger: 'item',
        formatter: showCounts ? '{c} {b}\n({d}%)' : '{b}\n({d}%)'
      },
      legend: {
        orient: 'horizontal',
        right: '0%',
        top: '1%',
        data: ['Present', 'Absent'],
        textStyle: { fontSize: 12 }
      },
      series: [
        {
          name: 'Attendance',
          type: 'pie',
          radius: ['30%', '70%'],
          center: ['50%', '55%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: true,
            formatter: showCounts
              ? '{count|{c}} {label|{b}}\n{percent|({d}%)}'
              : '{label|{b}}\n{percent|({d}%)}',
            rich: {
              count: {
                fontSize: 11,
                color: '#333'
              },
              label: {
                fontSize: 11,
                color: '#333'
              },
              percent: {
                fontSize: 15,
              }
            }
          },

          emphasis: {
            label: {
              show: true,
              fontSize: 13
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: [
            {
              value: present,
              name: '',
              itemStyle: { color: '#81C784' }
            },
            {
              value: absent,
              name: '',
              itemStyle: { color: '#E57373' }
            }
          ]
        }
      ]
    };
  };

  // === Master Data State ===
  // const [academicYears, setAcademicYears] = useState([]);
  const [classList, setClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [scheduleTypes, setScheduleTypes] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [chartType, setChartType] = useState('Stacked');

  // === Filter State ===
  const [selectedSchool, setSelectedSchool] = useState(userObj.school_id);
  const [selectedScheduleType, setSelectedScheduleType] = useState('');
  const [selectedSchedule, setSelectedSchedule] = useState('');
  const [scheduleClass, setScheduleClass] = useState('');
  const [scheduleSection, setScheduleSection] = useState('');

  // === Class Fee State ===
  const [classFeeClass, setClassFeeClass] = useState('');
  const [classFeeSection, setClassFeeSection] = useState('');
  const [classFeeSearch, setClassFeeSearch] = useState('');
  const [classFeeData, setClassFeeData] = useState([]);
  const [shouldLoadFeeReport, setShouldLoadFeeReport] = useState(false);

  // === Attendance State ===
  const [attendanceClass, setAttendanceClass] = useState(null);
  const [attendanceSection, setAttendanceSection] = useState(null);
  const [attendanceSearch, setAttendanceSearch] = useState('');
  const [attendanceData, setAttendanceData] = useState([]);
  const [reportType, setReportType] = useState('Monthly');
  const [selectedDailyMonth, setSelectedDailyMonth] = useState(new Date().toLocaleString('default', { month: 'long' }));
  const [studentAttendance, setStudentAttendance] = useState([]);
  const [monthlyClass, setMonthlyClass] = useState('');
  const [monthlySection, setMonthlySection] = useState('');
  const [monthlySearch, setMonthlySearch] = useState('');
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const currentMonthIndex = new Date().getMonth();
    return [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ][currentMonthIndex];
  });
  const [trendClass, setTrendClass] = useState(0);
  const [trendSection, setTrendSection] = useState(0);
  const [attendanceTrendDataMonthly, setAttendanceTrendDataMonthly] = useState([]);

  const [summaryClass, setSummaryClass] = useState('');
  const [summarySection, setSummarySection] = useState('');
  const [summaryAttendanceData, setSummaryAttendanceData] = useState({
    present: 0,
    absent: 0,
    total: 0
  });
  const [summaryTimeFilter, setSummaryTimeFilter] = useState('day'); // Options: 'day', 'week', 'month'

  // === Notifications & Events ===
  const [notifications, setNotifications] = useState([]);
  const [events, setEvents] = useState([]);
  const [date, setDate] = useState(new Date());
  const [selectedEvents, setSelectedEvents] = useState([]);

  // === Timetable ===
  const [timetable, setTimetable] = useState('');
  const [periods, setPeriods] = useState([]);
  const [weekdays, setWeekdays] = useState([]);

  // === UI State ===

  const [showModalAttendance, setShowModalAttendance] = useState(false);
  const [showModalFee, setShowModalFee] = useState(false);
  const [showModalSchedule, setShowModalSchedule] = useState(false);

  // === Fetch Functions ===
  // === Additional State ===
  const [selectedReport, setSelectedReport] = useState('trend');
  const [scheduleReportData, setScheduleReportData] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [showModalNotifications, setShowModalNotifications] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [homeworkFilter, setHomeworkFilter] = useState("This Month");

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [homeworkData, setHomeworkData] = useState([]);
  const [isLoadingFeeReport, setIsLoadingFeeReport] = useState(false);



  const formatMinutesToHours = (minutes) => {
    if (minutes == null || minutes === 0) return ''; // Hide if null or 0

    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hrs > 0 && mins > 0) return `${hrs} hr ${mins} mins`;
    if (hrs > 0) return `${hrs} hr`;
    return `${mins} mins`;
  };

  const fetchScheduleTypes = async () => {
    try {
      const response = await axios.post(`${baseUrl}/feescheduletype/`, {
        action: 'READ',
        school_id: selectedSchool,
      });

      const types = response.data || [];
      setScheduleTypes(types);

      const defaultType = types.find(st => st.is_default === 'Yes');
      if (defaultType) {
        setSelectedScheduleType(defaultType.fee_schedule_type_id);
      } else {
        setSelectedScheduleType('');
      }
    } catch (error) {
      console.error('Error fetching schedule types:', error);
    }
  };

  const fetchSchedules = async () => {
    try {
      const response = await axios.post(`${baseUrl}/feeschedule/`, {
        action: 'READ',
        school_id: selectedSchool,
        academic_year_id: selectedAcademicYear
      });

      const filtered = response.data?.filter(
        s => s.fee_schedule_type_id === Number(selectedScheduleType)
      ) || [];

      setSchedules(filtered);

      if (filtered.length > 0) {
        setSelectedSchedule(filtered[0].fee_schedule_id);
      } else {
        setSelectedSchedule('');
      }
    } catch (error) {
      console.error('Error fetching schedules:', error);
    }
  };
  const [selectedAcademicYear, setSelectedAcademicYear] = useState(userObj.academic_year_id);
  // useEffect(() => {
  //   if (selectedScheduleType && selectedSchedule && selectedAcademicYear) {
  //     fetchScheduleReport();
  //   } else {
  //     setScheduleReportData([]);
  //   }
  // }, [selectedScheduleType, selectedSchedule, selectedSchool, scheduleClass, scheduleSection, selectedAcademicYear]);

  useEffect(() => {
    if (selectedScheduleType && selectedSchedule && selectedAcademicYear) {
      fetchScheduleReport();
    } else {
      setScheduleReportData([]);
    }
  }, [selectedScheduleType, selectedSchedule, selectedSchool, selectedAcademicYear]);

  const fetchScheduleReport = () => {
    setIsLoadingFeeReport(true);

    const selectedScheduleObj = schedules.find(s => s.fee_schedule_id === Number(selectedSchedule));
    const endDate = selectedScheduleObj?.end_date || null;

    if (!endDate) {
      console.warn('Selected schedule does not have an end_date. Cannot call API.');
      setScheduleReportData([]);
      setIsLoadingFeeReport(false);
      return;
    }

    const payload = {
      school_id: selectedSchool,
      academic_year_id: selectedAcademicYear,
      fee_schedule_type_id: selectedScheduleType,
      fee_schedule_id: selectedSchedule,
      end_date: endDate,
      class_id: scheduleClass || null,
      section_id: scheduleSection || null,
      status: "A"
    };

    axios.post(baseUrl + '/feesschedulereport', payload)
      .then(res => {
        // console.log('API response:', res.data);

        let cleanArray = [];

        if (Array.isArray(res.data)) {
          cleanArray = res.data;
        } else if (Array.isArray(res.data?.data)) {
          cleanArray = res.data.data;
        } else if (Array.isArray(res.data?.result)) {
          cleanArray = res.data.result;
        } else {
          console.warn('Unexpected API format:', res.data);
        }

        setScheduleReportData(cleanArray);
      })
      .catch(error => {
        console.error('Error fetching fee report data:', error);
        setScheduleReportData([]);
      })
      .finally(() => {
        setIsLoadingFeeReport(false);
      });
  };
  useEffect(() => {
    const fetchAcademicYear = async () => {
      if (!selectedSchool) {
        setSelectedAcademicYear('');
        return;
      }

      try {
        const response = await axios.post(`${baseUrl}/AcademicYear/`, {
          action: 'CURRENTREAD',
          school_id: selectedSchool,
        });

        const academicYears = response.data || [];
        console.log("Fetched academic_year_id:", academicYears[0]?.academic_year_id);

        if (academicYears.length > 0) {
          setSelectedAcademicYear(academicYears[0].academic_year_id);
        } else {
          setSelectedAcademicYear('');
        }
        await fetchDropdownData('/classes/', setClassList);
        await fetchNotifications();

      } catch (error) {
        console.error('Error fetching academic year:', error);
        setSelectedAcademicYear('');
      }
    };

    fetchAcademicYear();

  }, [selectedSchool]);


  // 👇 Separate useEffect to observe the actual state change
  useEffect(() => {
    console.log("selectedAcademicYear has been updated to:", selectedAcademicYear);
  }, [selectedAcademicYear]);

  useEffect(() => {
    if (selectedReport === 'summary') {
      fetchAttendanceSummary(summaryClass, summarySection, summaryTimeFilter);
    }
  }, [summaryClass, summarySection, summaryTimeFilter, selectedReport]);


  const filteredAttendanceData = attendanceData
    ? attendanceData.filter(item =>
      (item.class_name || '').toLowerCase().includes(attendanceSearch.toLowerCase())
    )
    : [];

  const filteredMonthlyAttendance = studentAttendance
    ? studentAttendance.filter(item =>
      (item.student_name || '').toLowerCase().includes(monthlySearch.toLowerCase())
    )
    : [];

  const sortedTrendData = [...attendanceTrendDataMonthly].sort((a, b) => {
    const dayA = a?.day ?? "";
    const dayB = b?.day ?? "";
    return dayA.localeCompare(dayB);
  });


  // === Utility Functions ===
  const toggleFullscreen = () => setIsFullscreen(prev => !prev);

  const handleMaximize = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setShowModal(true);
  };

  const handleDayClick = (date) => {
    const dayEvents = events.filter(event =>
      new Date(event.start).toDateString() === date.toDateString()
    );
    setSelectedEvents(dayEvents);
  };
  const fetchHomeworkData = async () => {
    const payload = {
      action: "GET",
      filter_type: homeworkFilter,
      start_date: homeworkFilter === "Date Range" ? startDate : null,
      end_date: homeworkFilter === "Date Range" ? endDate : null,
      school_id: selectedSchool,
      academic_year_id: selectedAcademicYear,
    };

    try {
      const response = await axios.post(`${baseUrl}/homeworkfordashboard/`, payload);
      setHomeworkData(response.data);
    } catch (error) {
      console.error("Error fetching homework data:", error);
      setHomeworkData([]);
    }
  };
  useEffect(() => {
    if (homeworkFilter !== "Date Range") {
      fetchHomeworkData();
    }
  }, [homeworkFilter]);

  useEffect(() => {
    if (homeworkFilter === "Date Range" && startDate && endDate) {
      fetchHomeworkData();
    }
  }, [startDate, endDate]);
  // === Render Helpers ===
  const getReportTitle = () => {
    switch (selectedReport) {
      case 'daily':
        return 'Daily Attendance Report';
      case 'monthly':
        return 'Student Wise Monthly Attendance';
      case 'trend':
        return 'Attendance Trend Report';
      default:
        return '';
    }
  };
  const [homeworkChartType, setHomeworkChartType] = useState('bar');

  const getHomeworkChartOptions = () => {
    const categories = homeworkData.map(item => `${item.class_name}-${item.section_name}`);
    const completed = homeworkData.map(item =>
      parseFloat((item.percentage_complete || '0').replace('%', '')) || 0
    );
    const pending = homeworkData.map(item =>
      parseFloat((item.percentage_pending || '0').replace('%', '')) || 0
    );

    return {
      title: {
        left: 'center',
        top: 10,
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#333'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: function (params) {
          const total = (params[0].value + params[1].value).toFixed(2);
          return `
        ${params[0].name}<br/>
        <span style="color:#1abc9c">●</span> % Complete: ${params[0].value}%<br/>
        <span style="color:#e74c3c">●</span> % Pending: ${params[1].value}%<br/>
        <strong>Total: ${total}%</strong>
      `;
        }
      },
      legend: {
        top: 5,
        left: 'center',
        data: ['% Complete', '% Pending']
      },
      color: ['#81C784', '#E57373'],
      grid: {
        left: 30,
        right: 30,
        top: 60,     // reduce top padding
        bottom: 10,  // reduce bottom padding
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: homeworklabel,
        axisLabel: {
          rotate: 30,
          fontSize: 10
        }
      },
      yAxis: {
        type: 'value',
        max: 100,
        axisLabel: {
          formatter: '{value} %',
          fontSize: 10
        }
      },
      series: [
        {
          name: '% Complete',
          type: 'bar',
          stack: 'homework',
          data: completed
        },
        {
          name: '% Pending',
          type: 'bar',
          stack: 'homework',
          data: pending
        }
      ]
    };
  };
  const getHomeworkSummaryPieChartOptions = () => {
    // Sum all completed and pending percentages
    const totalCompleted = homeworkData.reduce((sum, item) => {
      return sum + parseFloat((item.percentage_complete || '0').replace('%', '')) || 0;
    }, 0);

    const totalPending = homeworkData.reduce((sum, item) => {
      return sum + parseFloat((item.percentage_pending || '0').replace('%', '')) || 0;
    }, 0);

    return {
      title: {

        left: 'center',
        top: 10,
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#333'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c}% ({d}%)'
      },
      legend: {
        orient: 'horizontal',
        top: 10,
        data: ['% Complete', '% Pending']
      },
      color: ['#81C784', '#E57373'],
      series: [
        {
          name: 'Homework Status',
          type: 'pie',
          radius: '60%',
          center: ['50%', '50%'],
          data: [
            { name: '% Complete', value: totalCompleted },
            { name: '% Pending', value: totalPending }
          ],
          label: {
            formatter: '{b}: {c}%'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  };

  const CardContent = () => (
    <Card style={{ fontSize: '13px', display: 'flex', flexDirection: 'column', }}>
      <Card.Header
        className="d-flex justify-content-between align-items-center py-2 px-3"
        style={{
          backgroundColor: '#f8f9fa',
          borderBottom: '1px solid #dee2e6',
          fontSize: '14px',
          flexShrink: 0
        }}
      >
        <strong>Homework Overview</strong>
        <div className="d-flex align-items-center gap-2">
          <Form.Select
            size="sm"
            value={homeworkFilter}
            onChange={(e) => setHomeworkFilter(e.target.value)}
            style={{ width: '130px' }}
          >
            <option>This Month</option>
            <option>This Week</option>
            <option>Today</option>
            <option>Date Range</option>
          </Form.Select>
          {homeworkFilter === "Date Range" && (
            <>
              <Form.Control
                type="date"
                size="sm"
                value={startDate}

                style={{ width: 'auto', minWidth: '40px', padding: '0PX' }}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <Form.Control
                type="date"
                size="sm"
                value={endDate}
                style={{ width: 'auto', minWidth: '40px', padding: '0PX' }}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </>
          )}
          <Button variant="outline-secondary" size="sm" onClick={toggleFullscreen} title="Expand Report">
            <BiFullscreen size={18} />
          </Button>
        </div>
      </Card.Header>

      <Card.Body className="px-3 py-2" style={{ flex: 1 }}>
        <Form.Label style={{ paddingRight: "5px" }}>Chart Type:</Form.Label>
        <Form.Check
          inline
          label="Bar"
          name="homeworkChartType"
          type="radio"
          id="bar"
          checked={homeworkChartType === 'bar'}
          onChange={() => setHomeworkChartType('bar')}
        />
        <Form.Check
          inline
          label="Pie"
          name="homeworkChartType"
          type="radio"
          id="pie"
          checked={homeworkChartType === 'pie'}
          onChange={() => setHomeworkChartType('pie')}
        />
        <ReactECharts
          option={
            homeworkChartType === 'pie'
              ? getHomeworkSummaryPieChartOptions()
              : getHomeworkChartOptions()
          }
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '250px' }}
        />
      </Card.Body>
    </Card>
  );

  const renderReportBody = () => {
    if (selectedReport === 'daily') {
      return (
        <div>
          <div style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', whiteSpace: 'nowrap', marginBottom: '1rem', gap: '8px' }}>
            <Form.Select size="sm" value={attendanceClass} onChange={(e) => { setAttendanceClass(e.target.value); setAttendanceSection(''); }} style={{ width: 'auto', minWidth: '100px' }}>
              <option value="">Class</option>
              {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
              ))}
            </Form.Select>

            <Form.Select size="sm" value={attendanceSection} onChange={(e) => setAttendanceSection(e.target.value)} disabled={!attendanceClass} style={{ width: 'auto', minWidth: '100px' }}>
              <option value="">Section</option>
              {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(attendanceClass)).map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
              ))}
            </Form.Select>

            <Form.Select size="sm" value={reportType} onChange={(e) => setReportType(e.target.value)} style={{ width: 'auto', minWidth: '100px' }}>
              <option value="Daily">Daily</option>
              <option value="Monthly">Monthly</option>
            </Form.Select>

            {reportType === 'Monthly' && (
              <Form.Select size="sm" value={selectedDailyMonth} onChange={(e) => setSelectedDailyMonth(e.target.value)} style={{ width: 'auto', minWidth: '100px' }}>
                <option value="">Month</option>
                {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                  <option key={index} value={month}>{month}</option>
                ))}
              </Form.Select>
            )}

            <Form.Control type="text" placeholder="Search..." size="sm" value={attendanceSearch} onChange={(e) => setAttendanceSearch(e.target.value)} style={{ width: 'auto', minWidth: '100px' }} />
          </div>

          <div style={{
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            background: '#fff',
            fontSize: '12px',
            overflow: 'hidden',
            marginTop: '5px'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '120px 130px 130px 130px',
              fontWeight: 600,
              backgroundColor: '#f1f3f5',
              padding: '6px 10px',
              borderBottom: '1px solid #dee2e6',
              textAlign: 'center',
              gap: "10px"
            }}>
              <div>Date</div>
              <div>Total Students</div>
              <div style={{ backgroundColor: '#d4edda' }}>Present</div>
              <div style={{ backgroundColor: '#f8d7da' }}>Absent</div>
            </div>

            <div style={{ maxHeight: '205px', overflowY: 'auto' }}>
              {filteredAttendanceData.length > 0 ? (
                filteredAttendanceData.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '120px 130px 130px 130px',
                      padding: '6px 10px',
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
                      textAlign: 'center',
                      borderBottom: '1px solid #eee',
                      gap: "10px"
                    }}
                  >
                    <div>{item.attendance_date.split("-").reverse().join("-")}</div>
                    <div>{item.total_students}</div>
                    <div>{item.total_present}</div>
                    <div>{item.total_absent}</div>
                  </div>
                ))
              ) : (
                <div style={{ padding: '8px', textAlign: 'center', color: '#888' }}>
                  No attendance data available.
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    if (selectedReport === 'monthly') {
      return (
        <div>
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <Form.Select size="sm" value={monthlyClass} onChange={(e) => { setMonthlyClass(e.target.value); setMonthlySection(''); }} style={{ width: 'auto', minWidth: '80px' }}>
              <option value="">Class</option>
              {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
              ))}
            </Form.Select>

            <Form.Select size="sm" value={monthlySection} onChange={(e) => setMonthlySection(e.target.value)} disabled={!monthlyClass} style={{ width: 'auto', minWidth: '80px' }}>
              <option value="">Section</option>
              {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(monthlyClass)).map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
              ))}
            </Form.Select>

            <Form.Select size="sm" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} style={{ width: 'auto', minWidth: '80px' }}>
              <option value="">Month</option>
              {[
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ].map((month, index) => (
                <option key={index} value={month}>{month}</option>
              ))}
            </Form.Select>

            <Form.Control type="text" placeholder="Search..." size="sm" value={monthlySearch} onChange={(e) => setMonthlySearch(e.target.value)} style={{ width: 'auto', minWidth: '80px' }} />
          </div>

          <div style={{
            border: '1px solid #dee2e6',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            background: '#fff',
            fontSize: '12px',
            overflow: 'hidden',
            marginTop: '10px'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '80px 140px 90px 90px 90px 100px',
              fontWeight: 400,
              backgroundColor: '#f1f3f5',
              borderBottom: '1px solid #dee2e6',
              textAlign: 'center',
            }}>
              <div>Roll No</div>
              <div>Student</div>
              <div>Days</div>
              <div style={{ backgroundColor: '#d4edda' }}>Present</div>
              <div style={{ backgroundColor: '#f8d7da' }}>Absent</div>
              <div style={{ backgroundColor: '#e2e3ff' }}>Percent</div>
            </div>

            <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
              {filteredMonthlyAttendance.length > 0 ? (
                filteredMonthlyAttendance.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '80px 140px 90px 90px 90px 100px',
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
                      textAlign: 'center',
                      borderBottom: '1px solid #eee',
                    }}
                  >
                    <div>{item.roll_no}</div>
                    <div style={{ textAlign: 'left' }}>{item.student_name}</div>
                    <div>{item.total_working_days}</div>
                    <div>{item.total_present}</div>
                    <div>{item.total_absent}</div>
                    <div>{item.present_percentage}</div>
                  </div>
                ))
              ) : (
                <div style={{ padding: '8px', textAlign: 'center', color: '#888' }}>
                  No attendance data available.
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    if (selectedReport === 'trend') {
      const totalPresent = sortedTrendData.reduce((sum, item) => sum + item.Present, 0);
      const totalAbsent = sortedTrendData.reduce((sum, item) => sum + item.Absent, 0);

      const chartOptions = trendChartType === 'pie'
        ? {
          tooltip: { trigger: 'item' },
          legend: { top: 5, left: 'center' },
          series: [
            {
              name: 'Attendance',
              type: 'pie',
              radius: ['40%', '70%'],
              center: ['50%', '60%'],
              avoidLabelOverlap: false,
              label: { show: false, position: 'center' },
              emphasis: {
                label: { show: true, fontSize: '18', fontWeight: 'bold' }
              },
              labelLine: { show: false },
              data: [
                { value: totalPresent, name: 'Present', itemStyle: { color: '#28a745' } },
                { value: totalAbsent, name: 'Absent', itemStyle: { color: '#dc3545' } }
              ]
            }
          ]
        }
        : {
          tooltip: { trigger: 'axis' },
          legend: { data: ['Present', 'Absent'], top: 10 },
          grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
          xAxis: {
            type: 'category',
            boundaryGap: trendChartType === 'Bar',
            data: sortedTrendData.map(item =>
              typeof item?.day === "string" ? item.day.slice(-2) : ""
            )
            ,
            axisLabel: {
              formatter: val => val
            }
          },
          yAxis: { type: 'value' },
          series: [
            {
              name: 'Present',
              type: trendChartType.toLowerCase(),
              data: sortedTrendData.map(item => item.Present),
              itemStyle: { color: '#28a745' },
              areaStyle: trendChartType === 'line' ? { color: 'rgba(40,167,69,0.2)' } : undefined
            },
            {
              name: 'Absent',
              type: trendChartType.toLowerCase(),
              data: sortedTrendData.map(item => item.Absent),
              itemStyle: { color: '#dc3545' },
              areaStyle: trendChartType === 'line' ? { color: 'rgba(220,53,69,0.2)' } : undefined
            }
          ]
        };

      return (
        <div>
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <Form.Select size="sm" value={trendClass} onChange={(e) => { setTrendClass(e.target.value); setTrendSection(''); }} style={{ width: '120px' }}>
              <option value="">Class</option>
              {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
              ))}
            </Form.Select>

            <Form.Select size="sm" value={trendSection} onChange={(e) => setTrendSection(e.target.value)} disabled={!trendClass} style={{ width: 'auto', minWidth: '120px' }}>
              <option value="">Section</option>
              {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(trendClass)).map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
              ))}
            </Form.Select>

            <Form.Select size="sm" value={selectedMonth} onChange={(e) => {
              const month = e.target.value;
              setSelectedMonth(month);
              if (trendClass && trendSection && month) {
                fetchAttendanceTrendData(trendClass, trendSection, month);
              }
            }} style={{ width: 'auto', minWidth: '120px' }}>
              <option value="">Month</option>
              {[
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ].map((month, index) => (
                <option key={index} value={month}>{month}</option>
              ))}
            </Form.Select>

            {/* <Form.Group className="d-flex align-items-center gap-3">
              <Form.Check
                inline
                type="radio"
                label="Bar Chart"
                name="chartType"
                id="bar-chart"
                value="bar"
                checked={trendChartType === 'bar'}
                onChange={(e) => setTrendChartType(e.target.value)}
              />
              <Form.Check
                inline
                type="radio"
                label="Pie Chart"
                name="chartType"
                id="pie-chart"
                value="pie"
                checked={trendChartType === 'pie'}
                onChange={(e) => setTrendChartType(e.target.value)}
              />
            </Form.Group> */}

          </div>

          <ReactECharts
            key={trendChartType}
            option={getTrendChartOption()}
            style={{ height: '240px', width: '100%', marginTop: '20px' }}
          />
        </div>
      );
    }
    if (selectedReport === 'summary') {
      return (
        <div>
          <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
            {/* Class Select */}
            <Form.Select
              size="sm"
              value={summaryClass}
              onChange={(e) => {
                setSummaryClass(e.target.value);
                setSummarySection('');
              }}
              style={{ width: 'auto', minWidth: '120px', fontSize: '12px' }}
            >
              <option value="">All Classes</option>
              {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
              ))}
            </Form.Select>

            {/* Section Select */}
            <Form.Select
              size="sm"
              value={summarySection}
              onChange={(e) => setSummarySection(e.target.value)}
              disabled={!summaryClass}
              style={{ width: 'auto', minWidth: '120px', fontSize: '12px' }}
            >
              <option value="">All Sections</option>
              {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(summaryClass)).map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
              ))}
            </Form.Select>

            {/* Time Filter */}
            <Form.Select
              size="sm"
              value={summaryTimeFilter}
              onChange={(e) => setSummaryTimeFilter(e.target.value)}
              style={{ width: 'auto', minWidth: '120px', fontSize: '12px' }}
            >
              <option value="day">This Day</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
            </Form.Select>

            {/* Summary Display: count for day, percentage for week/month */}
            <div style={{
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#495057',
              marginLeft: 'auto'
            }}>
              {summaryTimeFilter === 'day' ? (
                <>
                  Present: {summaryAttendanceData.present} &nbsp;
                  Absent: {summaryAttendanceData.absent} &nbsp;
                  Total: {summaryAttendanceData.total}
                </>
              ) : (
                <>
                  Attendance Percentage:&nbsp;
                  {summaryAttendanceData.total > 0
                    ? `${((summaryAttendanceData.present / summaryAttendanceData.total) * 100).toFixed(1)}%`
                    : 'N/A'}
                </>
              )}
            </div>
          </div>

          {/* Chart or Message */}
          {summaryAttendanceData.total > 0 ? (
            <ReactECharts
              option={getSummaryChartOption()}
              style={{ height: '280px', width: '100%' }}
            />
          ) : (
            <div style={{
              height: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#888',
              fontSize: '14px',
              border: '1px dashed #ddd',
              borderRadius: '6px'
            }}>
              No attendance data available for selected period
            </div>
          )}
        </div>
      );
    }

    return null;
  };

  const handleShowDetails = (note) => {
    setSelectedNotification(note);
    setShowModalNotifications(true);
  };
  const renderNotificationList = (list = []) => {
    if (list.length === 0) {
      return <div className="fst-italic ps-3">No notifications available</div>;
    }

    const sortedList = [...list].sort((a, b) => {
      const aDate = moment(a.createddate).startOf('day');
      const bDate = moment(b.createddate).startOf('day');
      return bDate.diff(aDate);
    });

    return (
      <ul className="ps-0 mb-0" style={{ listStyle: 'none' }}>
        {sortedList.map((note, index) => {
          const dateLabel = getDateLabel(note?.createddate);
          const isToday = dateLabel === 'Today';

          return (
            <li
              key={index}
              className="mb-1 d-flex justify-content-between align-items-center"
              style={{
                backgroundColor: isToday ? '#e6f7ff' : '#f8f9fa',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '0.85rem',
                boxShadow: '0 0 2px rgba(0,0,0,0.05)',
              }}
            >
              <div style={{ flex: 1 }}>
                <div className="fw-semibold" style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>
                  {note?.subject || 'No subject'}
                </div>
                <div style={{ fontSize: '0.7rem', color: '#888' }}>{dateLabel}</div>
              </div>

              {/* Optional: Replace with icon or remove this if not needed */}
              <button
                className="btn btn-sm btn-link text-primary"
                style={{ fontSize: '0.75rem', padding: '2px 6px' }}
                onClick={() => handleShowDetails(note)}
              >
                Details
              </button>
            </li>
          );
        })}
      </ul>
    );
  };


  const getDateLabel = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  };



  const fetchDropdownData = async (endpoint, setter) => {
    try {
      const response = await axios.post(baseUrl + endpoint, {
        action: 'READ',
        school_id: selectedSchool,
      });
      setter(response.data || []);
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
    }
  };

  const fetchDropdownDatasection = async (endpoint, setter) => {
    try {
      const response = await axios.post(baseUrl + endpoint, {
        action: 'READ',
        school_id: selectedSchool,
        academic_year_id: selectedAcademicYear
      });
      setter(response.data || []);
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
    }
  };

  const fetchSchoolList = async () => {
    try {
      const response = await axios.post(baseUrl + '/schoolmaster/', {
        action: 'READ',
        school_id: userObj.school_id
      });
      setSchoolList(response.data || []);
    } catch (error) {
      console.error('Error fetching schools:', error);
    }
  };



  const fetchTimetable = async () => {
    try {
      const response = await axios.post(baseUrl + '/teachertimetable/', {
        action: 'READ',
        school_id: selectedSchool,
        teacher_id: userObj?.user_id || 0
      });

      const data = response.data;
      if (Array.isArray(data)) {
        setTimetable(data);
      } else if (data?.data && Array.isArray(data.data)) {
        setTimetable(data.data);
      } else {
        setTimetable([]);
      }
    } catch (error) {
      console.error('Error fetching timetable:', error);
      setTimetable([]);
    }
  };

  const fetchNotifications = async () => {
    try {
      const response = await axios.post(baseUrl + '/notifications/', {
        action: 'READ',
        school_id: selectedSchool
      });
      setNotifications(response.data || []);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const fetchEvents = async () => {
    try {
      const response = await axios.post(`${baseUrl}/events/`, {
        action: "READ",
        school_id: userObj?.school_id || 0,
      });
      const formattedEvents = (response.data || []).map((event) => ({
        ...event,
        id: event.event_id,
        start: new Date(event.event_date),
        end: new Date(event.event_date),
      }));
      setEvents(formattedEvents);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };
  const [isLoadingClassFee, setIsLoadingClassFee] = useState(false);
  const [selectedChartClass, setSelectedChartClass] = useState(null);
  const [selectedChartSection, setSelectedChartSection] = useState(null);
  const [showClassFeeTable, setShowClassFeeTable] = useState(false);

  const fetchClassFeeReport = async (classId, sectionId) => {
    try {
      setIsLoadingClassFee(true);

      const params = {
        _school_id: Number(selectedSchool),
        _academic_year_id: Number(selectedAcademicYear),
        _class_id: Number(classId),
        _section_id: Number(sectionId),
        _status: 'A'
      };

      const response = await axios.get(baseUrl + '/main/teacherappfeeofeverystudnet', { params });
      const studentData = response?.data?.[0]?.getstudentfeesummarywithdue ?? [];
      setClassFeeData(studentData);
    } catch (error) {
      console.error('Error fetching class fee report:', error.response?.data || error.message);
      setClassFeeData([]);  // optionally clear on error
    } finally {
      setIsLoadingClassFee(false);
    }
  };


  const fetchAttendanceReport = async () => {
    try {
      const isDaily = reportType === 'Daily';
      const requestBody = {
        school_id: selectedSchool,
        class_id: attendanceClass,
        section_id: attendanceSection,
        academic_year_id: selectedAcademicYear,
        attendance_date: new Date().toISOString().split('T')[0],
        month_name: selectedDailyMonth,
        action: isDaily ? 'FILTER' : 'GET',
      };

      const endpoint = isDaily ? '/dailyattendancefordashboard' : '/monthlyattendance';
      const response = await axios.post(baseUrl + endpoint, requestBody);
      setAttendanceData(response.data || []);
    } catch (error) {
      console.error('Error fetching attendance report:', error);
    }
  };

  const fetchStudentAttendance = async (classId, sectionId, monthName) => {
    try {
      const response = await axios.post(baseUrl + '/studentmonthlyattendance/', {
        action: 'GET',
        school_id: selectedSchool,
        academic_year_id: selectedAcademicYear,
        class_id: monthlyClass,
        section_id: monthlySection,
        month_name: selectedMonth,
      });
      setStudentAttendance(response.data || []);
    } catch (error) {
      console.error('Error fetching student attendance:', error);
    }
  };
  const receivedData = scheduleReportData.map(item => item.total_paid);
  const notReceivedData = scheduleReportData.map(item => item.total_amount_to_be_paid);

  const totalReceived = scheduleReportData.reduce((sum, item) => sum + item.total_paid, 0);
  console.log(totalReceived)
  const totalNotReceived = scheduleReportData.reduce((sum, item) => sum + item.total_amount_to_be_paid, 0);

  const maxAmount = Math.max(
    ...scheduleReportData.map(item => item.total_paid + item.total_amount_to_be_paid)
  );




  const fetchAttendanceTrendData = async () => {
    try {
      const requestBody = {
        school_id: selectedSchool,
        class_id: trendClass,
        section_id: trendSection,
        academic_year_id: selectedAcademicYear,
        month_name: selectedMonth,
        action: 'GET',
      };

      const response = await axios.post(baseUrl + '/monthlyattendance/', requestBody);
      const rawData = response.data || [];
      const trendData = rawData.map(record => ({
        day: record.attendance_date,
        Present: Number(record.total_present) || 0,
        Absent: Number(record.total_absent) || 0,
      }));
      setAttendanceTrendDataMonthly(trendData);
    } catch (error) {
      console.error('Error fetching attendance trend data:', error);
    }
  };
  // At the top of the component
  useEffect(() => {
    fetchEmployeeAttendance();
  }, [employeeAttendanceDate]);

  useEffect(() => {
    fetchStudentAttendance();
  }, [monthlyClass, monthlySection, selectedMonth]);
  // === Master Data Load (Only Once) ===
  useEffect(() => {
    const loadMasterData = async () => {
      try {
        await Promise.all([
          // fetchDropdownData('/classes/', setClassList),
          // fetchDropdownDatasection('/Sections/', setSectionList),
          // fetchDropdownData("/AcademicYear/", setAcademicYears),
          // fetchTimetable(),
          // fetchNotifications(),
          fetchEvents(),

        ]);

        if (userObj?.role_name === "Director") {
          fetchSchoolList();
        }

        fetchScheduleTypes();
      } catch (error) {
        console.error('Error loading initial data:', error);
      }
    };

    loadMasterData();
  }, []);

  // === Schedule Types / Schedules ===
  useEffect(() => {
    if (selectedSchool && selectedAcademicYear) {
      fetchScheduleTypes();
      fetchHomeworkData();

      fetchDropdownDatasection('/Sections/', setSectionList);

    }
  }, [selectedSchool, selectedAcademicYear]);


  useEffect(() => {
    if (selectedScheduleType && selectedAcademicYear) {
      fetchSchedules();
    }
  }, [selectedScheduleType, selectedSchool, selectedAcademicYear]);

  // === Attendance Reports ===
  useEffect(() => {
    if (attendanceClass && attendanceSection && reportType) {
      fetchAttendanceReport();
    }
  }, [attendanceClass, attendanceSection, reportType, selectedDailyMonth]);

  // === Class Fee Report ===
  useEffect(() => {
    if (classFeeClass && classFeeSection) {
      fetchClassFeeReport(classFeeClass, classFeeSection);
    }
  }, [classFeeClass, classFeeSection]);

  // === Attendance Trend Data ===
  useEffect(() => {
    if (trendClass && trendSection && selectedMonth) {
      fetchAttendanceTrendData();
    }
  }, [trendClass, trendSection, selectedMonth]);

  useEffect(() => {
    if (!selectedSchool) return;

    const activeClasses = classList.filter(cls => cls?.is_active === "Active");
    if (activeClasses.length > 0) {
      const firstClassId = activeClasses[0].class_id;

      setAttendanceClass(firstClassId);
      setMonthlyClass(firstClassId);
      setTrendClass(firstClassId);
      setClassFeeClass(firstClassId);

      const matchingSections = sectionList.filter(sec =>
        sec?.is_active === "Active" && sec.class_id === firstClassId
      );
      if (matchingSections.length > 0) {
        const firstSectionId = matchingSections[0].section_id;
        setAttendanceSection(firstSectionId);
        setMonthlySection(firstSectionId);
        setTrendSection(firstSectionId);
        setClassFeeSection(firstSectionId);
      }
    }
  }, [selectedSchool, classList, sectionList]);



  useEffect(() => {
    if (monthlyClass && !monthlySection) {
      const firstSection = sectionList.find(
        sec => sec?.is_active === "Active" && sec.class_id === Number(monthlyClass)
      );
      if (firstSection) setMonthlySection(firstSection.section_id);
    }
  }, [monthlyClass, sectionList]);

  useEffect(() => {
    if (trendClass && !trendSection) {
      const firstSection = sectionList.find(
        sec => sec?.is_active === "Active" && sec.class_id === Number(trendClass)
      );
      if (firstSection) setTrendSection(firstSection.section_id);
    }
  }, [trendClass, sectionList]);

  useEffect(() => {
    if (classFeeClass && !classFeeSection) {
      const firstSection = sectionList.find(
        sec => sec?.is_active === "Active" && sec.class_id === Number(classFeeClass)
      );
      if (firstSection) setClassFeeSection(firstSection.section_id);
    }
  }, [classFeeClass, sectionList]);
  const fetchFeeReportData = async () => {
    try {
      const response = await axios.post(`${baseUrl}/dashboardfeerport/`, {
        action: 'FILTER',
        school_id: selectedSchool,
        academic_year_id: selectedAcademicYear,
        fee_schedule_type_id: selectedScheduleType,
        fee_schedule_id: selectedSchedule,
        class_id: scheduleClass,
        section_id: scheduleSection
      });
      setScheduleReportData(response.data || []);
    } catch (error) {
      console.error('Error fetching fee report data:', error);
      setScheduleReportData([]);
    }
  };
  useEffect(() => {
    if (
      shouldLoadFeeReport &&
      selectedReport === 'fee' &&
      selectedScheduleType &&
      selectedSchedule &&
      scheduleClass &&
      scheduleSection &&
      selectedAcademicYear
    ) {
      fetchFeeReportData();
      setShouldLoadFeeReport(false); // Reset trigger
    }
  }, [
    shouldLoadFeeReport,
    selectedReport,
    selectedScheduleType,
    selectedSchedule,
    scheduleClass,
    scheduleSection,
    selectedAcademicYear
  ]);
  const handleFeeReportClassChange = (classId) => {
    setScheduleClass(classId);
    setScheduleSection('');
    setShouldLoadFeeReport(true); // Manual trigger
  };

  const handleFeeReportSectionChange = (sectionId) => {
    setScheduleSection(sectionId);
    setShouldLoadFeeReport(true); // Manual trigger
  };

  const labels = scheduleReportData.map(item => {
    const cleanClass = item.class_name?.includes('Class')
      ? item.class_name.replace(' Class', '')
      : item.class_name;
    return `${cleanClass}-${item.section_name}`;
  });
  const homeworklabel = homeworkData.map(item => {
    const cleanClass = item.class_name?.includes('Class')
      ? item.class_name.replace(' Class', '')
      : item.class_name;
    return `${cleanClass}-${item.section_name}`;
  });
  const getChartOption = () => {
    if (chartType === 'Stacked') {
      return {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { top: 12 },
        grid: { left: '1%', bottom: '-2%', containLabel: true },
        xAxis: { type: 'category', data: labels, axisLabel: { rotate: 30 } },
        yAxis: { type: 'value', name: 'Amount (₹)', max: maxAmount },
        series: [
          {
            name: 'Amount Received',
            type: 'bar',
            stack: 'Total',
            data: receivedData,
            itemStyle: { color: '#81C784' }
          },
          {
            name: 'Amount Not Received',
            type: 'bar',
            stack: 'Total',
            data: notReceivedData,
            itemStyle: { color: '#E57373' }
          }
        ]
      };
    }

    if (chartType === 'Pie') {
      return {
        tooltip: { trigger: 'item', formatter: '{b}: ₹{c} ({d}%)' },
        legend: { top: 10, left: 'center' },
        series: [
          {
            name: 'Amount Summary',
            type: 'pie',
            radius: '65%',
            data: [
              { value: totalReceived, name: 'Amount Received' },
              { value: totalNotReceived, name: 'Amount Not Received' }
            ],
            itemStyle: {
              borderRadius: 8,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: { formatter: '{b}: ₹{c}\n({d}%)' },
            color: ['#81C784', '#E57373']
          }
        ]
      };
    }

    return {};
  };

  useEffect(() => {
    if (selectedSchool) {
      setSelectedScheduleType('');
      setSelectedSchedule('');
      fetchScheduleTypes();

    } else {
      setScheduleTypes([]);
      setSchedules([]);
      setSelectedScheduleType('');
      setSelectedSchedule('');
    }
  }, [selectedSchool]);

  const renderClassFeeExpandedView = () => (
    <div
      className="custom-fee-table"
      style={{
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        background: '#fff',
        fontSize: '12px',
        overflow: 'hidden'
      }}
    >
      <div
        className="table-header"
        style={{
          display: 'grid',
          gridTemplateColumns: '80px 1fr 100px 100px 100px 100px',
          fontWeight: '600',
          backgroundColor: '#f1f3f5',
          padding: '8px 12px',
          borderBottom: '1px solid #dee2e6',
          textAlign: 'center'
        }}
      >
        <div>Adm No</div>
        <div style={{ textAlign: 'left' }}>Name</div>
        <div>Total Fee</div>
        <div>Paid</div>
        <div>Current Due</div>
        <div>Balance</div>
      </div>

      <div
        className="table-scroll-body"
        style={{ maxHeight: '255px', overflowY: 'auto' }}
      >
        {isLoadingClassFee ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <img src={loading} alt="Loading..." height={40} />
          </div>
        ) : classFeeData.length === 0 ? (
          <div style={{ padding: '10px', textAlign: 'center', color: '#888' }}>
            No records found.
          </div>
        ) : (
          classFeeData
            .filter((item) =>
            (item.student_name ?? '').toLowerCase().includes(classFeeSearch.toLowerCase())
 ||
              String(item.roll_no).includes(classFeeSearch)
            )
            .map((item, index) => (
              <div
                className="table-row"
                key={index}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '80px 1fr 100px 100px 100px 100px',
                  padding: '6px 12px',
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
                  textAlign: 'center',
                  alignItems: 'center',
                  borderBottom: '1px solid #eee'
                }}
              >
                <div>{item.admission_number}</div>
                <div style={{ fontSize: '12px', textAlign: 'left' }}>{item.student_name}</div>
                <div>₹ {item.total_fee}</div>
                <div>₹ {item.total_paid}</div>
                <div
                  style={{
                    fontWeight: 'bold',
                    color: item.amount_to_be_paid > 0 ? '#dc3545' : '#28a745',
                    backgroundColor: item.amount_to_be_paid > 0 ? '#f8d7da' : '#d4edda',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    marginRight: "5px",
                    display: 'inline-block'
                  }}
                >
                  ₹ {item.amount_to_be_paid || 0}
                </div>
                <div
                  style={{
                    fontWeight: 'bold',
                    color: item.balance > 0 ? '#dc3545' : '#28a745',
                    backgroundColor: item.balance > 0 ? '#f8d7da' : '#d4edda',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    display: 'inline-block'
                  }}
                >
                  ₹ {item.balance}
                </div>
              </div>
            ))
        )}
      </div>
    </div>
  );


  // Time helper: "13:05:00" → "1:05 PM"
  const formatTime12Hour = (time) => {
    if (!time) return "-";

    // time can be "HH:MM" or "HH:MM:SS"
    const parts = String(time).split(":");
    if (parts.length < 2) return time; // fallback

    let [hoursStr, minutesStr] = parts;
    let hours = parseInt(hoursStr, 10);
    const minutes = minutesStr.padStart(2, "0");

    if (isNaN(hours)) return time;

    const amPm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${hours}:${minutes} ${amPm}`;
  };

  const exportClassFeeToExcel = () => {
    if (!classFeeData || classFeeData.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    const rows = classFeeData.map(item => ({
      "Admission No": item.admission_number || '',
      "Student Name": item.student_name || '',
      "Total Fee": item.total_fee || 0,
      "Paid": item.total_paid || 0,
      "Current Due": item.amount_to_be_paid || 0,
      "Balance": item.balance || 0
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ClassFeeReport");
    XLSX.writeFile(workbook, "Class_Fee_Report.xlsx");
  };
  const exportClassFeeToPDF = () => {
    if (!classFeeData || classFeeData.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Class Fee Report", 14, 15);

    const columns = ["Admission No", "Student Name", "Total Fee", "Paid", "Current Due", "Balance"];
    const rows = classFeeData.map(item => [
      item.admission_number || '',
      item.student_name || '',
      item.total_fee || 0,
      item.total_paid || 0,
      item.amount_to_be_paid || 0,
      item.balance || 0
    ]);

    autoTable(doc, {
      startY: 20,
      head: [columns],
      body: rows,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [41, 128, 185] }
    });

    doc.save("Class_Fee_Report.pdf");
  };

  const employeeGridTemplate = "1.7fr 1.1fr 1fr 1fr 1fr 1fr 0.9fr 1.1fr";

  return (
    <div className="pageBody">
      <ToastContainer />
      <div className="">
        {userObj?.role_name === "Director" && (
          <>
            {/* 👈 LEFT SIDE: Director - School Logo, Name, Dropdown */}
            <div className="d-flex align-items-center gap-2">
              <Image
                src={apiUrl} // ✅ Replace with actual logo URL
                alt="School Logo"
                style={{ width: '50px', height: '20px', objectFit: 'cover', paddingLeft: "20px" }}
                fluid
                rounded
              />
              <span style={{ fontSize: '20px', fontWeight: 500 }}>
                {userObj?.school_name || 'No School'}
              </span>
              <Form.Select
                size="sm"
                value={selectedSchool || ''}
                onChange={(e) => setSelectedSchool(e.target.value || '')}
                style={{ width: '150px', fontSize: '12px' }}
              >
                <option value="">Branch</option>
                {(schoolList || []).filter(s => s?.status === "Active").map(s => (
                  <option key={s?.school_id} value={s?.school_id}>
                    {s?.branch || 'Unnamed'}
                  </option>
                ))}
              </Form.Select>
            </div>

            {/* 👉 RIGHT SIDE: User Profile */}
            <div className="rightNavigations">
              <div className="profileInfo d-flex align-items-center gap-3">
                <div className="profileInfoLeft text-end">
                  <h6 className="user mb-0">{userObj.user_name}</h6>
                  <p className="role mb-0">{userObj.role_name}</p>
                </div>
                <div className="profileInfoRight">
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      variant="link"
                      bsPrefix="p-0 border-0 shadow-none"
                      id="dropdown-basic"
                    >
                      <Image src={avatarUrl || loginPhoto} alt="Account" fluid />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="shadow-sm">
                      <Dropdown.Item onClick={handleLogout}>
                        <FaSignOutAlt className="me-2" /> Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <Container fluid className="dashboard-container px-2 px-md-4 p-0">

        <Row className="g-4">
          <Col xs={12} md={6}>
            <Card style={{ fontSize: '12px' }}>
              <Card.Header
                className="d-flex align-items-center justify-content-between py-1 px-2"
                style={{ gap: '6px', flexWrap: 'nowrap', fontSize: '13px' }}
              >
                <h6 className="mb-0" style={{ flexShrink: 0, fontSize: '18px' }}>Fee Report</h6>

                <div className="d-flex align-items-center flex-wrap" style={{ gap: '4px', flexGrow: 1, justifyContent: 'flex-end' }}>


                  <Form.Select
                    size="sm"
                    value={selectedScheduleType || ''}
                    onChange={(e) => {
                      setSelectedScheduleType(e.target.value || '');
                      setSelectedSchedule('');
                    }}
                    style={{ width: '90px' }}
                  >
                    <option value="">Type</option>
                    {(scheduleTypes || []).filter(st => st?.is_active === "Active").map(st => (
                      <option key={st?.fee_schedule_type_id} value={st?.fee_schedule_type_id}>
                        {st?.fee_schedule_type_name || 'Unnamed'}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Select
                    size="sm"
                    value={selectedSchedule || ''}
                    onChange={(e) => setSelectedSchedule(e.target.value || '')}
                    disabled={!selectedScheduleType}
                    style={{ width: '100px' }}
                  >
                    <option value="">Schedule</option>
                    {(selectedScheduleType && schedules || []).map(s => (
                      <option key={s?.fee_schedule_id} value={s?.fee_schedule_id}>
                        {s?.schedule_name || 'Unnamed'}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Select
                    size="sm"
                    value={scheduleClass || ''}
                    // onChange={(e) => {
                    //   setScheduleClass(e.target.value || '');
                    //   setScheduleSection('');
                    // }}
                    onChange={(e) => handleFeeReportClassChange(e.target.value || '')}
                    style={{ width: '100px' }}
                  >
                    <option value="">Class</option>
                    {(classList || []).filter(cls => cls?.is_active === "Active").map(cls => (
                      <option key={cls?.class_id} value={cls?.class_id}>
                        {cls?.class_name || 'Unnamed'}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Select
                    size="sm"
                    value={scheduleSection || ''}
                    // onChange={(e) => setScheduleSection(e.target.value || '')}
                    onChange={(e) => handleFeeReportSectionChange(e.target.value || '')}
                    disabled={!scheduleClass}
                    style={{ width: '100px' }}
                  >
                    <option value="">Section</option>
                    {(sectionList || []).filter(sec =>
                      sec?.is_active === "Active" && Number(sec?.class_id) === Number(scheduleClass)
                    ).map(sec => (
                      <option key={sec?.section_id} value={sec?.section_id}>
                        {sec?.section_name || 'Unnamed'}
                      </option>
                    ))}
                  </Form.Select>

                  <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Expand Report"
                    onClick={() => setShowModalSchedule(true)}
                    style={{ padding: '0.2rem 0.4rem' }}
                  >
                    <BiFullscreen size={14} />
                  </Button>
                </div>
              </Card.Header>

              <Card.Body style={{ height: '298px', overflowY: 'auto', padding: '8px' }}>
                {showClassFeeTable ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => setShowClassFeeTable(false)}
                        className="mb-1"
                      >
                        ←
                      </Button>

                      <div>
                        <img onClick={exportClassFeeToExcel} src={excelIcon} alt="Excel" style={{ border: "none", background: "none", width: 20, marginRight: 15 }} />
                        <img onClick={exportClassFeeToPDF} src={pdfIcon} alt="PDF" style={{ border: "none", background: "none", width: 20, marginLeft: 5, marginRight: 15 }} />
                      </div>
                    </div>

                    {renderClassFeeExpandedView()}
                  </>
                ) : isLoadingFeeReport ? (
                  <div className="text-center p-2">
                    <img src={loading} alt="Loading..." height={30} />
                  </div>
                ) : scheduleReportData?.length > 0 ? (
                  <>
                    <div className="d-flex align-items-center gap-3 mb-2">
                      <label style={{ margin: 0, fontSize: '12px' }}>Chart Type:</label>

                      <div style={{ fontSize: '12px' }}>
                        <input
                          type="radio"
                          id="normal"
                          name="chartType"
                          value="Stacked"
                          checked={chartType === 'Stacked'}
                          onChange={(e) => setChartType(e.target.value)}
                          style={{ marginRight: '5px' }}
                        />
                        <label htmlFor="normal">Normal</label>
                      </div>

                      <div style={{ fontSize: '12px' }}>
                        <input
                          type="radio"
                          id="summary"
                          name="chartType"
                          value="Pie"
                          checked={chartType === 'Pie'}
                          onChange={(e) => setChartType(e.target.value)}
                          style={{ marginRight: '5px' }}
                        />
                        <label htmlFor="summary">Summary</label>
                      </div>
                    </div>




                    <ReactECharts
                      key={chartType}
                      option={getChartOption()}
                      style={{ height: '250px' }}
                      onEvents={{
                        click: (params) => {
                          if (params.componentType === 'series' && params.seriesType === 'bar') {
                            const label = params.name;
                            let className = '';
                            let sectionName = '';

                            if (label.includes('-')) {
                              const parts = label.split('-');
                              className = parts[0].trim() + ' Class';
                              sectionName = parts[1].trim();
                            } else {
                              return;
                            }

                            const classObj = classList.find(cls =>
                              cls.class_name.trim().toLowerCase() === className.toLowerCase()
                            );

                            const sectionObj = sectionList.find(sec =>
                              sec.section_name.trim().toLowerCase() === sectionName.toLowerCase() &&
                              sec.class_id === classObj?.class_id
                            );

                            if (classObj && sectionObj) {
                              setSelectedChartClass(classObj.class_id);
                              setSelectedChartSection(sectionObj.section_id);
                              fetchClassFeeReport(classObj.class_id, sectionObj.section_id);
                              setShowClassFeeTable(true);
                            }
                          }
                        }
                      }}
                    />
                  </>
                ) : (
                  <div style={{ padding: '4px', textAlign: 'center', color: '#888', fontSize: '12px' }}>
                    No data available.
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={6}>
            <Card style={{ fontSize: "12px" }}>
              <Card.Header
                className="d-flex align-items-center justify-content-between py-1 px-2"
                style={{ gap: "6px", flexWrap: "nowrap", fontSize: "13px" }}
              >
                <h6 className="mb-0" style={{ flexShrink: 0, fontSize: "18px" }}>
                  Employee Attendance
                </h6>

                <div
                  className="d-flex align-items-center flex-wrap"
                  style={{ gap: "4px", flexGrow: 1, justifyContent: "flex-end" }}
                >
                  {/* Daywise / Trend */}
                  <Form.Select
                    size="sm"
                    value={employeeView}
                    onChange={(e) => setEmployeeView(e.target.value)}
                    style={{ width: "110px" }}
                  >
                    <option value="Daywise">Daywise</option>
                    {/* <option value="Trend">Trend</option> */}
                  </Form.Select>

                  {/* Date */}
                  <Form.Control
                    type="date"
                    size="sm"
                    value={employeeAttendanceDate}
                    onChange={(e) => setEmployeeAttendanceDate(e.target.value)}
                    style={{ width: "130px" }}
                  />

                  {/* Fullscreen */}
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => setShowEmployeeAttendanceModal(true)}
                    title="Expand Report"
                  >
                    <BiFullscreen size={18} />
                  </Button>
                </div>
              </Card.Header>

              <Card.Body style={{ height: "298px", padding: "0px" }}>
                <div
                  style={{
                    border: "1px solid #e1e5eb",
                    borderRadius: "6px",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    margin: "0 8px 0 8px",
                  }}
                >
                  {/* 🔥 Header + rows inside SAME scroll container */}
                  <div style={{ maxHeight: "240px", overflowY: "auto" }}>
                    {/* Header row (sticky) */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: employeeGridTemplate,
                        backgroundColor: "#007bff",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "11px",
                        padding: "6px 10px",
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      <div style={{ textAlign: "left", paddingLeft: "2px" }}>Name</div>
                      <div style={{ textAlign: "center" }}>Shift</div>
                      <div style={{ textAlign: "center" }}>In Time</div>
                      <div style={{ textAlign: "center" }}>Late In</div>
                      <div style={{ textAlign: "center" }}>Out Time</div>
                      <div style={{ textAlign: "center" }}>Early Out</div>
                      <div style={{ textAlign: "center" }}>No. of Hrs</div>
                      <div style={{ textAlign: "center" }}>Type</div>

                    </div>

                    {/* Body rows */}
                    {isLoadingEmployee ? (
                      <div
                        style={{
                          padding: "12px",
                          textAlign: "center",
                          fontSize: "12px",
                        }}
                      >
                        Loading...
                      </div>
                    ) : employeeAttendance && employeeAttendance.length > 0 ? (
                      employeeAttendance.map((row, index) => (
                        <div
                          key={row.emp_attend_id || index}
                          style={{
                            display: "grid",
                            gridTemplateColumns: employeeGridTemplate, // ✅ same as header
                            fontSize: "11px",
                            padding: "6px 10px",
                            backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                            borderBottom: "1px solid #f3f4f6",
                            alignItems: "center",
                          }}
                        >
                          {/* Name */}
                          <div
                            title={row.user_name}
                            style={{ textAlign: "left", fontWeight: 500 }}
                          >
                            {row.user_name || "-"}
                          </div>

                          {/* Shift */}
                          <div style={{ textAlign: "center" }}>
                            {row.shift_name || "-"}
                          </div>

                          {/* In Time */}
                          <div style={{ textAlign: "center" }}>
                            {row.in_time ? formatTime12Hour(row.in_time) : "-"}
                          </div>

                          {/* Late In (hrs) */}
                          <div style={{ textAlign: "center" }}>
                            {formatMinutesToHours(row.late_time)}
                          </div>

                          {/* Out Time */}
                          <div style={{ textAlign: "center" }}>
                            {row.out_time ? formatTime12Hour(row.out_time) : "-"}
                          </div>

                          {/* Early Out (hrs) */}
                          <div style={{ textAlign: "center" }}>
                            {formatMinutesToHours(row.early_time)}
                          </div>

                          {/* No. of Hrs */}
                          <div style={{ textAlign: "center" }}>
                             {formatMinutesToHours(row.no_of_hours)}
                          </div>

                          {/* Type */}
                          <div
                            style={{
                              textAlign: "center",
                              fontWeight: 600,
                              color:
                                row.attendance_type_name === "Present"
                                  ? "#198754"
                                  : row.attendance_type_name === "Absent"
                                    ? "#dc3545"
                                    : "#212529",
                            }}
                          >
                            {row.attendance_type_name || "-"}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          padding: "16px",
                          textAlign: "center",
                          fontSize: "12px",
                          color: "#777",
                        }}
                      >
                        No rows
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>






        </Row>
        <Row className="g-4">
          <Col xs={12} md={6}>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center py-2 px-3">
                <h5 className="mb-0" style={{ fontSize: '16px' }}>Attendance Reports</h5>
                <div className="d-flex align-items-center gap-2">
                  <Form.Select
                    size="sm"
                    value={selectedReport}
                    onChange={(e) => setSelectedReport(e.target.value)}
                    style={{ width: 'auto', minWidth: '150px', fontSize: '13px' }}
                  >
                    <option value="daily">Daily Attendance Report</option>
                    <option value="monthly">Student Wise Monthly Attendance</option>
                    <option value="trend">Attendance Trend Report</option>
                    <option value="summary">Attendance Summary</option>
                  </Form.Select>
                  <Button variant="outline-secondary" size="sm" onClick={() => setShowModalAttendance(true)} title="Expand Report">
                    <BiFullscreen size={18} />
                  </Button>
                </div>
              </Card.Header>

              <Card.Body style={{ padding: '5px' }}>
                {/* === DAILY ATTENDANCE === */}
                {selectedReport === 'daily' && (
                  <div>
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                      <Form.Select size="sm" value={attendanceClass} onChange={(e) => { setAttendanceClass(e.target.value); setAttendanceSection(''); }} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Class</option>
                        {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                          <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
                        ))}
                      </Form.Select>

                      <Form.Select size="sm" value={attendanceSection} onChange={(e) => setAttendanceSection(e.target.value)} disabled={!attendanceClass} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Section</option>
                        {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(attendanceClass)).map(sec => (
                          <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
                        ))}
                      </Form.Select>

                      <Form.Select size="sm" value={reportType} onChange={(e) => setReportType(e.target.value)} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="Daily">Daily</option>
                        <option value="Monthly">Monthly</option>
                      </Form.Select>

                      {reportType === 'Monthly' && (
                        <Form.Select size="sm" value={selectedDailyMonth} onChange={(e) => {
                          setSelectedDailyMonth(e.target.value);
                          if (attendanceClass && attendanceSection && e.target.value) {
                            fetchAttendanceReport(attendanceClass, attendanceSection, e.target.value);
                          }
                        }} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                          <option value="">Month</option>
                          {[
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                          ].map((month, index) => (
                            <option key={index} value={month}>{month}</option>
                          ))}
                        </Form.Select>
                      )}

                      <Form.Control type="text" placeholder="Search..." size="sm" value={attendanceSearch} onChange={(e) => setAttendanceSearch(e.target.value)} style={{ width: '30px', minWidth: '100px', fontSize: '12px' }} />
                    </div>

                    {/* Grid Header */}
                    <div style={{
                      border: '1px solid #dee2e6',
                      borderRadius: '6px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      background: '#fff',
                      fontSize: '12px',
                      overflow: 'hidden'
                    }}>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: '120px 110px 100px 100px',
                        fontWeight: 600,
                        backgroundColor: '#f1f3f5',
                        padding: '6px 8px',
                        textAlign: 'center'
                      }}>
                        <div>Date</div>
                        <div>Total</div>
                        <div style={{ backgroundColor: '#d4edda' }}>Present</div>
                        <div style={{ backgroundColor: '#f8d7da' }}>Absent</div>
                      </div>

                      <div style={{ maxHeight: '205px', overflowY: 'auto' }}>
                        {filteredAttendanceData.length > 0 ? (
                          filteredAttendanceData.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '120px 110px 100px 100px',
                                padding: '6px 8px',
                                backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                textAlign: 'center'
                              }}
                            >
                              <div>{item.attendance_date.split("-").reverse().join("-")}</div>
                              <div>{item.total_students}</div>
                              <div>{item.total_present}</div>
                              <div>{item.total_absent}</div>
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: '6px', textAlign: 'center', color: '#888' }}>
                            No attendance data available.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* === STUDENT MONTHLY ATTENDANCE === */}
                {selectedReport === 'monthly' && (
                  <div>
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                      <Form.Select size="sm" value={monthlyClass} onChange={(e) => { setMonthlyClass(e.target.value); setMonthlySection(''); }} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Class</option>
                        {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                          <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
                        ))}
                      </Form.Select>

                      <Form.Select size="sm" value={monthlySection} onChange={(e) => setMonthlySection(e.target.value)} disabled={!monthlyClass} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Section</option>
                        {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(monthlyClass)).map(sec => (
                          <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
                        ))}
                      </Form.Select>

                      <Form.Select size="sm" value={selectedMonth} onChange={(e) => {
                        const month = e.target.value;
                        setSelectedMonth(month);
                        if (monthlyClass && monthlySection && month) {
                          fetchStudentAttendance(monthlyClass, monthlySection, month);
                        }
                      }} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Month</option>
                        {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                          <option key={index} value={month}>{month}</option>
                        ))}
                      </Form.Select>

                      <Form.Control type="text" placeholder="Search..." size="sm" value={monthlySearch} onChange={(e) => setMonthlySearch(e.target.value)} style={{ width: 'auto', minWidth: '100px', fontSize: '12px' }} />
                    </div>

                    {/* Monthly Grid */}
                    <div style={{
                      border: '1px solid #dee2e6',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      background: '#fff',
                      fontSize: '12px',
                      overflow: 'hidden'
                    }}>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: '80px 130px 70px 80px 80px 90px',
                        fontWeight: 600,
                        backgroundColor: '#f1f3f5',
                        textAlign: 'center'
                      }}>
                        <div>Roll No</div>
                        <div>Student</div>
                        <div>Days</div>
                        <div style={{ backgroundColor: '#d4edda' }}>Present</div>
                        <div style={{ backgroundColor: '#f8d7da' }}>Absent</div>
                        <div style={{ backgroundColor: '#e2e3ff' }}>%</div>
                      </div>

                      <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
                        {filteredMonthlyAttendance.length > 0 ? (
                          filteredMonthlyAttendance.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '80px 130px 70px 80px 80px 90px',
                                backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                textAlign: 'center'
                              }}
                            >
                              <div>{item.roll_no}</div>
                              <div style={{ textAlign: 'left' }}>{item.student_name}</div>
                              <div>{item.total_working_days}</div>
                              <div>{item.total_present}</div>
                              <div>{item.total_absent}</div>
                              <div>{item.present_percentage}</div>
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: '6px', textAlign: 'center', color: '#888' }}>
                            No attendance data available.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* === TREND CHART === */}
                {selectedReport === 'trend' && (
                  <div>
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                      <Form.Select size="sm" value={trendClass} onChange={(e) => { setTrendClass(e.target.value); setTrendSection(''); }} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Class</option>
                        {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                          <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
                        ))}
                      </Form.Select>

                      <Form.Select size="sm" value={trendSection} onChange={(e) => setTrendSection(e.target.value)} disabled={!trendClass} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Section</option>
                        {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(trendClass)).map(sec => (
                          <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
                        ))}
                      </Form.Select>

                      <Form.Select size="sm" value={selectedMonth} onChange={(e) => {
                        const month = e.target.value;
                        setSelectedMonth(month);
                        if (trendClass && trendSection && month) {
                          fetchAttendanceTrendData(trendClass, trendSection, month);
                        }
                      }} style={{ width: 'auto', minWidth: '90px', fontSize: '12px' }}>
                        <option value="">Month</option>
                        {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                          <option key={index} value={month}>{month}</option>
                        ))}
                      </Form.Select>

                      {/* <Form.Check type="radio" label="Bar" name="chartType" value="bar" checked={trendChartType === "bar"} onChange={(e) => setTrendChartType(e.target.value)} style={{ fontSize: '12px' }} /> */}
                      {/* <Form.Check type="radio" label="Pie" name="chartType" value="pie" checked={trendChartType === "pie"} onChange={(e) => setTrendChartType(e.target.value)} style={{ fontSize: '12px' }} /> */}
                    </div>

                    <ReactECharts
                      key={trendChartType}
                      option={getTrendChartOption()}
                      style={{ height: '240px', width: '100%' }}
                    />
                  </div>
                )}
                {/* === ATTENDANCE SUMMARY === */}
                {selectedReport === 'summary' && (
                  <div>
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                      {/* Class Select */}
                      <Form.Select
                        size="sm"
                        value={summaryClass}
                        onChange={(e) => {
                          setSummaryClass(e.target.value);
                          setSummarySection('');
                        }}
                        style={{ width: 'auto', minWidth: '120px', fontSize: '12px' }}
                      >
                        <option value="">All Classes</option>
                        {classList.filter(cls => cls?.is_active === "Active").map(cls => (
                          <option key={cls.class_id} value={cls.class_id}>{cls.class_name}</option>
                        ))}
                      </Form.Select>

                      {/* Section Select */}
                      <Form.Select
                        size="sm"
                        value={summarySection}
                        onChange={(e) => setSummarySection(e.target.value)}
                        disabled={!summaryClass}
                        style={{ width: 'auto', minWidth: '120px', fontSize: '12px' }}
                      >
                        <option value="">All Sections</option>
                        {sectionList.filter(sec => sec?.is_active === "Active" && sec?.class_id === Number(summaryClass)).map(sec => (
                          <option key={sec.section_id} value={sec.section_id}>{sec.section_name}</option>
                        ))}
                      </Form.Select>

                      {/* Time Filter: Day/Week/Month */}
                      <Form.Select
                        size="sm"
                        value={summaryTimeFilter}
                        onChange={(e) => setSummaryTimeFilter(e.target.value)}
                        style={{ width: 'auto', minWidth: '120px', fontSize: '12px' }}
                      >
                        <option value="day">This Day</option>
                        <option value="week">This Week</option>
                        <option value="month">This Month</option>
                      </Form.Select>

                      {/* Total Students */}
                      {/* Summary Display: count for day, percentage for week/month */}
                      <div style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#495057',
                        marginLeft: 'auto'
                      }}>
                        {summaryTimeFilter === 'day' ? (
                          <>
                            Present: {summaryAttendanceData.present} &nbsp;
                            Absent: {summaryAttendanceData.absent} &nbsp;
                            Total: {summaryAttendanceData.total}
                          </>
                        ) : (
                          <>
                            Attendance Percentage :
                            {summaryAttendanceData.total > 0
                              ? `${((summaryAttendanceData.present / summaryAttendanceData.total) * 100).toFixed(1)}%`
                              : 'N/A'}
                          </>
                        )}
                      </div>

                    </div>

                    {/* Chart or Message */}
                    {summaryAttendanceData.total > 0 ? (
                      <>
                        <ReactECharts
                          option={getSummaryChartOption()}
                          style={{ height: '280px', width: '100%' }}
                        />
                      </>
                    ) : (
                      <div style={{
                        height: '200px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#888',
                        fontSize: '14px',
                        border: '1px dashed #ddd',
                        borderRadius: '6px'
                      }}>
                        No attendance data available for selected period
                      </div>
                    )}
                  </div>
                )}

              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6}>
            {CardContent()}
          </Col>

        </Row>
        <Row className="g-4 mt-1">
          <Col xs={12} md={6}>
            <TimetableForm
              school_id={selectedSchool}
              academic_year_id={selectedAcademicYear}
              classList={classList}           // ✅ Add this
              sectionList={sectionList}       // ✅ And this
            />
          </Col>
          <Col xs={12} md={6}>
            <Card>
              <Card.Header
                className="d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  borderBottom: '1px solid #dee2e6',
                  fontSize: '0.9rem',
                }}
              >
                <h6 style={{ margin: 0 }}>Notifications</h6>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  title="Expand Notifications"
                  onClick={() =>
                    handleMaximize(
                      'My Notifications',
                      <div style={{ fontSize: '0.85rem', maxHeight: '300px', overflowY: 'auto' }}>
                        {renderNotificationList(notifications)}
                      </div>
                    )
                  }
                >
                  <FaExpand size={18} />
                </Button>

              </Card.Header>

              <Card.Body style={{ padding: '1rem', fontSize: '0.85rem' }}>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  {renderNotificationList(notifications)}
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>
        <Row className="g-4 mt-1">
          <Col xs={12} md={6} className="mb-4" style={{ maxHeight: '390px', overflowY: 'auto' }}>
            <Card>
              <Card.Header
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "8px",
                  backgroundColor: '#f8f9fa',
                  borderBottom: '1px solid #dee2e6',
                  fontSize: '0.9rem'
                }}
              >
                <h6 style={{ margin: 0 }}>Event Calendar </h6>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  title="Expand Calendar"
                  onClick={() =>
                    handleMaximize(
                      'Event Calendar',
                      <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start', fontSize: '0.85rem' }}>
                        <div>
                          <Calendar
                            value={date}
                            onChange={handleDayClick}
                            tileContent={({ date: tileDate, view }) => {
                              if (view === 'month') {
                                const hasEvent = events.some(
                                  (event) => new Date(event.start).toDateString() === tileDate.toDateString()
                                );
                                return hasEvent ? (
                                  <div style={{ textAlign: 'center', color: 'red', fontSize: '1rem' }}>•</div>
                                ) : null;
                              }
                            }}
                          />
                        </div>
                        <div style={{ flex: 1, maxWidth: '300px', overflowY: 'auto' }}>
                          <h6 style={{ marginTop: 0 }}>All Events</h6>
                          {events.length > 0 ? (
                            <ul className="mb-0 ps-3">
                              {events.map((event) => (
                                <li key={event.id} className="mb-2" style={{ fontSize: '0.8rem' }}>
                                  <strong>{event.title || 'Untitled Event'}</strong>
                                  <br />
                                  <small className="text-muted">{new Date(event.start).toLocaleDateString()}</small>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="fst-italic">No events available.</p>
                          )}
                        </div>
                      </div>
                    )
                  }
                >
                  <FaExpand size={18} />
                </Button>
              </Card.Header>
              <Card.Body style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem', fontSize: '0.85rem' }}>
                {/* Calendar Section */}
                <div style={{ display: 'flex', gap: '1rem' }}>
                  <div style={{ flex: '0 0 280px' }}>
                    <Calendar
                      value={date}
                      onChange={(selectedDate) => {
                        handleDayClick(selectedDate);
                        setDate(selectedDate);
                      }}
                      tileContent={({ date: tileDate, view }) => {
                        if (view === 'month') {
                          const hasEvent = events.some(
                            (event) => new Date(event.start).toDateString() === tileDate.toDateString()
                          );
                          return hasEvent ? (
                            <div style={{ textAlign: 'center', color: 'red', fontSize: '1rem' }}>•</div>
                          ) : null;
                        }
                      }}
                    />
                  </div>
                  <div style={{ flex: 1, maxHeight: '15rem', display: 'flex', flexDirection: 'column' }}>
                    <h6 className="mb-2">All Events</h6>
                    <ul className="flex-grow-1 overflow-auto ps-3 mb-0">
                      {events.length === 0 ? (
                        <li className="fst-italic">No events available</li>
                      ) : (
                        events.map((event) => (
                          <li key={event.id} className="mb-2">
                            <strong>{event.title || ''}</strong>
                            <br />
                            <small className="text-muted">{new Date(event.start).toLocaleDateString()}</small>
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* Maximize Modal */}
      <>
        <style>
          {`
      .modal-xxl-custom {
        max-width: 1140px;
        width: 100%;
      }
    `}
        </style>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          dialogClassName="modal-xxl-custom"
          style={{ zIndex: 1050 }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: '70vh',
              overflowY: 'auto',
              overflowX: 'hidden',
              padding: '20px',
            }}
          >
            {modalContent}
          </Modal.Body>
        </Modal>
        <Modal
          show={showModalAttendance}
          onHide={() => setShowModalAttendance(false)}
          dialogClassName="modal-xl"
          centered
        >
          <Modal.Header closeButton className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 w-100">
              <Modal.Title className="mb-0">{getReportTitle()}</Modal.Title>
              <Form.Select
                size="sm"
                value={selectedReport}
                onChange={(e) => setSelectedReport(e.target.value)}
                style={{ width: '250px', marginLeft: "520px" }}
              >
                <option value="daily">Daily Attendance Report</option>
                <option value="monthly">Student Wise Monthly Attendance</option>
                <option value="trend">Attendance Trend Report</option>
                <option value="summary">Attendance Summary</option>
              </Form.Select>
            </div>
          </Modal.Header>

          <Modal.Body>
            {renderReportBody()}
          </Modal.Body>
        </Modal>
        <Modal
          show={showModalSchedule}
          onHide={() => setShowModalSchedule(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Fee Report</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* --- Filter Controls --- */}
            <div
              className="d-flex align-items-center flex-wrap mb-3"
              style={{ gap: '10px', justifyContent: 'flex-start' }}
            >


              <Form.Select
                size="sm"
                value={selectedScheduleType || ''}
                onChange={(e) => {
                  setSelectedScheduleType(e.target.value || '');
                  setSelectedSchedule('');
                }}
                style={{ width: '140px', flexShrink: 0 }}
              >
                <option value="">Schedule Type</option>
                {(scheduleTypes || [])
                  .filter(st => st?.is_active === "Active")
                  .map(st => (
                    <option key={st?.fee_schedule_type_id} value={st?.fee_schedule_type_id}>
                      {st?.fee_schedule_type_name || 'Unnamed'}
                    </option>
                  ))}
              </Form.Select>

              <Form.Select
                size="sm"
                value={selectedSchedule || ''}
                onChange={(e) => setSelectedSchedule(e.target.value || '')}
                disabled={!selectedScheduleType}
                style={{ width: '140px', flexShrink: 0 }}
              >
                <option value="">Schedule</option>
                {(selectedScheduleType && schedules || []).map(s => (
                  <option key={s?.fee_schedule_id} value={s?.fee_schedule_id}>
                    {s?.schedule_name || 'Unnamed'}
                  </option>
                ))}
              </Form.Select>

              <Form.Select
                size="sm"
                value={scheduleClass || ''}
                // onChange={(e) => {
                //   setScheduleClass(e.target.value || '');
                //   setScheduleSection('');
                // }}
                onChange={(e) => handleFeeReportClassChange(e.target.value || '')}
                style={{ width: '120px', flexShrink: 0 }}
              >
                <option value="">Class</option>
                {(classList || [])
                  .filter(cls => cls?.is_active === "Active")
                  .map(cls => (
                    <option key={cls?.class_id} value={cls?.class_id}>
                      {cls?.class_name || 'Unnamed'}
                    </option>
                  ))}
              </Form.Select>

              <Form.Select
                size="sm"
                value={scheduleSection || ''}
                // onChange={(e) => setScheduleSection(e.target.value || '')}
                onChange={(e) => handleFeeReportSectionChange(e.target.value || '')}
                disabled={!scheduleClass}
                style={{ width: '120px', flexShrink: 0 }}
              >
                <option value="">Section</option>
                {(scheduleClass && sectionList || [])
                  .filter(sec => sec?.is_active === "Active" && Number(sec?.class_id) === Number(scheduleClass))
                  .map(sec => (
                    <option key={sec?.section_id} value={sec?.section_id}>
                      {sec?.section_name || 'Unnamed'}
                    </option>
                  ))}
              </Form.Select>
            </div>

            {/* --- Chart Area --- */}
            <Card>
              <Card.Body style={{ height: '300px', overflowY: 'auto' }}>
                {showClassFeeTable ? (
                  <>
                    <Button variant="secondary" size="sm" onClick={() => setShowClassFeeTable(false)} className="mb-1">
                      ←
                    </Button>

                    {renderClassFeeExpandedView()}
                  </>
                ) : isLoadingFeeReport ? (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <img src={loading} alt="Loading..." height={40} />
                  </div>
                ) : scheduleReportData && scheduleReportData.length > 0 ? (
                  <>
                    <Form.Group style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
                      <Form.Label style={{ margin: 0, fontWeight: 600 }}>View:</Form.Label>
                      <Form.Check
                        inline
                        label="Normal"
                        name="chartType"
                        type="radio"
                        id="normal-bar"
                        checked={chartType === 'Stacked'}
                        onChange={() => setChartType('Stacked')}
                      />
                      <Form.Check
                        inline
                        label="Summary"
                        name="chartType"
                        type="radio"
                        id="summary-pie"
                        checked={chartType === 'Pie'}
                        onChange={() => setChartType('Pie')}
                      />
                    </Form.Group>

                    <ReactECharts
                      key={chartType}
                      option={getChartOption()}
                      style={{ height: '300px' }}
                      onEvents={{
                        click: (params) => {
                          if (params.componentType === 'series' && params.seriesType === 'bar') {
                            const label = params.name; // e.g., "III-A"
                            let className = '';
                            let sectionName = '';

                            if (label.includes('-')) {
                              const parts = label.split('-');
                              className = parts[0].trim() + ' Class';  // ✅ Add ' Class' suffix
                              sectionName = parts[1].trim();
                            } else {
                              return; // Invalid label format
                            }

                            const classObj = classList.find(cls =>
                              cls.class_name.trim().toLowerCase() === className.toLowerCase()
                            );

                            const sectionObj = sectionList.find(sec =>
                              sec.section_name.trim().toLowerCase() === sectionName.toLowerCase() &&
                              sec.class_id === classObj?.class_id
                            );

                            if (classObj && sectionObj) {
                              setSelectedChartClass(classObj.class_id);
                              setSelectedChartSection(sectionObj.section_id);
                              fetchClassFeeReport(classObj.class_id, sectionObj.section_id);
                              setShowClassFeeTable(true);
                            } else {
                              console.warn("Could not match class or section:", className, sectionName);
                            }
                          }
                        }
                      }}
                    />


                  </>
                ) : (
                  <div style={{ padding: '10px', textAlign: 'center', color: '#888' }}>
                    No data available.
                  </div>
                )}
              </Card.Body>


            </Card>
          </Modal.Body>
        </Modal>


        <Modal
          show={isFullscreen}
          onHide={toggleFullscreen}
          size="xl"

          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Homework Overview
              <FaCompress className="ms-3" style={{ cursor: 'pointer' }} onClick={toggleFullscreen} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{CardContent()}</Modal.Body>
        </Modal>

        <Modal
          show={showModalFee}
          onHide={() => setShowModalFee(false)}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {renderClassFeeExpandedView()}
          </Modal.Body>
        </Modal>
        <Modal show={showModalNotifications} onHide={() => setShowModalNotifications(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selectedNotification?.subject || 'Notification'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>


            <p style={{ fontSize: '0.75rem', color: '#6c757d', marginBottom: '4px' }}>
              <strong>Date:</strong> {getDateLabel(selectedNotification?.createddate)}
            </p>

            {/* Subject */}
            <p style={{ fontSize: '0.75rem', color: '#6c757d', marginBottom: '4px' }}>
              <strong>Subject:</strong> {selectedNotification?.subject || 'No Subject'}
            </p>

            {/* Description */}
            <p style={{ fontSize: '0.75rem', color: '#6c757d', marginBottom: '4px' }}>
              <strong>Description:</strong> {selectedNotification?.description || 'No description available.'}
            </p>


            {/* File Preview (PDF or Image) */}
            {selectedNotification?.image_path?.endsWith('.pdf') && (
              <div className="mb-3">
                <iframe
                  src={`${baseUrl}/uploads/get-image/${selectedNotification.image_path}`}
                  title="PDF Viewer"
                  width="100%"
                  height="400px"
                  style={{ border: '1px solid #ccc', borderRadius: '6px' }}
                />
              </div>
            )}

            {/\.(jpg|jpeg|png|gif)$/i.test(selectedNotification?.image_path || '') && (
              <div className="mb-2 text-center">
                <img
                  src={`${baseUrl}/uploads/get-image/${selectedNotification.image_path}`}
                  alt="Notification Attachment"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '300px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  }}
                />
              </div>
            )}
          </Modal.Body>




        </Modal>
        <Modal
          show={showEmployeeAttendanceModal}
          onHide={() => setShowEmployeeAttendanceModal(false)}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Employee Attendance - {employeeAttendanceDate}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* Scrollable container */}
            <div
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                border: "1px solid #e1e5eb",
                borderRadius: "6px",
                backgroundColor: "#fff",
              }}
            >
              <Table
                hover
                size="sm"
                className="mb-0 emp-attendance-table"
                borderless
              >
                <thead className="sticky-top emp-attendance-header">
                  <tr>
                    <th>Name</th>
                    <th>Shift</th>
                    <th>In Time</th>
                    <th>Late In</th>
                    <th>Out Time</th>
                    <th>Early Out</th>
                    <th>No. of Hrs</th>
                    <th>Type</th>
                  </tr>
                </thead>

                <tbody>
                  {employeeAttendance?.map((row, index) => (
                    <tr key={index}>
                      <td title={row.user_name}>{row.user_name || "-"}</td>
                      <td>{row.shift_name || "-"}</td>
                      <td>{row.in_time ? formatTime12Hour(row.in_time) : "-"}</td>
                      <td>{row.late_time != null ? `${row.late_time} min` : "-"}</td>
                      <td>{row.out_time ? formatTime12Hour(row.out_time) : "-"}</td>
                      <td>{row.early_time != null ? `${row.early_time} min` : "-"}</td>
                      <td>{row.no_of_hours != null ? `${row.no_of_hours} min` : "-"}</td>
                      <td
                        className={
                          row.attendance_type_name === "Present"
                            ? "emp-present"
                            : row.attendance_type_name === "Absent"
                              ? "emp-absent"
                              : ""
                        }
                      >
                        {row.attendance_type_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setShowEmployeeAttendanceModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>




      </>
    </div>
  );
};
export default Dashboard; 